import React, { FC, useCallback } from 'react';
import { parse, format } from 'date-fns';

import Icon from '../../../Icon';
import Text from '../../../Typography/Text';

import { INewsItemInfo } from './interfaces';

import './styles.scss';

// news item
const NewsItemInfo: FC<INewsItemInfo> = ({
  title,
  intro,
  date,
  lang
}) => {
  const dataFormat = parse(date, 'yyyy-MM-dd', new Date());

  // get date
  const getDate = useCallback(() => {
    const value = lang !== 'en' ? format(dataFormat, 'dd/MM/yyyy') : format(dataFormat, 'MM/dd/yyyy');

    return value;
  }, [ dataFormat, lang ]);


  // truncate text with optional custom ellipsis
  const truncateText = useCallback((text: string | undefined, maxLength: number, ellipsis: string = '...') => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return `${text.substring(0, maxLength)}${ellipsis}`;
  }, []);


  // render
  return (
    <div className="news-item-info">
      <div className="news-item-info--year">
        <Icon icon="icon-text-dg" />
        <p className="text">{getDate()}</p>
      </div>
      <div className="news-item-info--description">
        <p className="title">{truncateText(title, 65)}</p>
        <Text attrs={{ className: 'description' }} type="danger" text={truncateText(intro, 113, ' [...]')} />
        <span className="icon-plus"></span>
      </div>
    </div>
  );
};

export default NewsItemInfo;